import { ReactElement } from "react"

import MappingPriceProvider from "../../../../providers/MappingPricesContext"

type Props = {
  mappingSchemaId: number
  children: ReactElement
}

const MappingStepWrapper = ({ mappingSchemaId, children }: Props): ReactElement => {
  return <MappingPriceProvider id={mappingSchemaId?.toString() ?? ""}>{children}</MappingPriceProvider>
}

export default MappingStepWrapper
